import callAPiBase from './base';

const messageTagsApi = {
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/tags/message',
      method: 'POST',
      useToken: true,
      data,
    }),
  delete: ({
    ID,
    messageID,
    Room,
    conversationStatus,
  }: {
    ID: string;
    messageID: number;
    Room: string;
    conversationStatus: number;
  }) =>
    callAPiBase({
      endpoint: `/api/tags/message?ID=${ID}&id=${messageID}&room=${Room}&conversationStatus=${conversationStatus}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { messageTagsApi };
export default messageTagsApi;
